import { Button, Tooltip } from 'flowbite-react';
import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../Common/Loader';
import { useAppSelector } from '../../Reducers/store';
import EquipmentApi from '../../Api/EquipmentApi';
import { HiPlus } from 'react-icons/hi';
import { EquipmentVideo } from '../../Models/EquipmentVideo';
import EquipmentVideoListTable from './EquipmentVideoListTable';
import AddEquipmentVideoModal from './AddEquipmentVideoModal';

export default function EquipmentVideoList({
  equipmentId,
}: {
  equipmentId: number;
}) {
  const { userModel } = useAppSelector((state) => state.user);
  const [equipmentVideoListData, setEquipmentVideoListData] = useState<
    EquipmentVideo[]
  >([]);
  const [selectedEquipmentVideo, setSelectedEquipmentVideo] =
    useState<EquipmentVideo | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showAddEquipmentVideo, setshowAddEquipmentVideo] =
    useState<boolean>(false);

  const getEquipmentVideoList = useCallback(() => {
    if (userModel) {
      try {
        setIsLoading(true);
        return EquipmentApi.getEquipmentVideoList(equipmentId)
          .then((res) => {
            setEquipmentVideoListData(res.data);
            setIsLoading(false);
          })
          .catch((err) => {
            toast.error('Error');
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error('Error');
        setIsLoading(false);
      }
    }
  }, [userModel]);

  useEffect(() => {
    getEquipmentVideoList();
  }, [getEquipmentVideoList]);

  const handleAddEquipmentVideoClick = () => {
    setSelectedEquipmentVideo(null);
    setshowAddEquipmentVideo(true);
  };

  const editEquipmentVideo = (video: EquipmentVideo) => {
    setSelectedEquipmentVideo(video);
    setshowAddEquipmentVideo(true);
  };

  function deleteEquipmentVideo(id: number) {
    const shouldRemove = window.confirm(
      'Are you sure you want to delete this?'
    );

    if (shouldRemove) {
      EquipmentApi.deleteEquipmentVideo(id)
        .then((res) => {
          if (res.data.success) {
            toast.success(res.data.message);
            getEquipmentVideoList();
          } else {
            toast.success('Error while deleting item');
          }
        })
        .catch((err) => {
          toast.error('Error: ' + err);
        });
    }
  }
  function checkAccess() {
    if (userModel) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
      <div className='w-full'>
        {checkAccess() && (
          <div className='w-full flex justify-end'>
            <Tooltip content={`Add Video`}>
              <Button
                onClick={handleAddEquipmentVideoClick}
                className='buttonMain'
              >
                <HiPlus size={20} />
              </Button>
            </Tooltip>
          </div>
        )}
        <div className='w-full p-4'>
          {isLoading && <Loader />}
          <EquipmentVideoListTable
            data={equipmentVideoListData}
            deleteEquipmentVideo={deleteEquipmentVideo}
            editEquipmentVideo={editEquipmentVideo}
          />
        </div>
      </div>
      <AddEquipmentVideoModal
        show={showAddEquipmentVideo}
        setShow={setshowAddEquipmentVideo}
        equipmentId={equipmentId}
        getEquipmentVideos={getEquipmentVideoList}
        equipmentVideo={selectedEquipmentVideo}
      />
    </>
  );
}
